import axios from 'axios';

export function updateScreenName(token, { userId, screenId, screenName }) {
    return axios.post(`${process.env.REACT_APP_API_URL}/updateScreenName`, {
        userId,
        screenId,
        screenName,
    }, {
        headers: {
            Authorization: `${token}`,
        },
    });
}
